/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import Immutable from 'immutable';
import {declareEditEntity, MetaDataHelper} from '../../common/fw/MetaDataHelper.ts';
import {injectIntl, FormattedMessage, defineMessages, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import config from '../../common/config';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {EditorWithSubmit} from '../fw/EditorWithSubmit.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';
import ConfigFlowMutation from './ConfigFlowMutation.react';
import {displayError} from '../app/errorDisplayer';
import {FLOW_OPTION_DEF_OPTIONS_KEY} from "../../common/model-api/FlowOptionDefType";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import {variableResolver} from '../../common/util/VariableResolver';
import {getQueryParams} from '../../common/util/QueryParams';
import { getLocalizedText } from '../../server/lib/getLocalizedText';
import { getLocale } from '../basicLocales';
import { renderLoadingPanel } from '../loadingLine/renderLoadingPanel.react';
import { ACCESS_TYPE_DEVELOPER, ACCESS_TYPE_PARTNER1, ACCESS_TYPE_PARTNER2 } from '../../common/model-api/UserType';
import mutationError from '../channel-defs/mutationError';
import { User } from '../../common/types/types';
import PlayPauseFlowMutation from './PlayPauseFlowMutation.react';
import { hasRequiredValue } from '../fw/formValueValidation.ts';
import { ScenarioApply } from '../scenarios/ScenarioApply.react.js';

const messages = defineMessages({
	example: {id: 'channelOptionEdit.example', 'defaultMessage': 'Example:'},
    title: {id: 'flowConfig.title', 'defaultMessage': 'Editing flow option'},
    save: {id: 'action.saveOptions', 'defaultMessage': 'Save options'},
    options: {id: 'flowConfig.options', 'defaultMessage': 'Options'},
	saveConfig: {id: 'flowConfig.saveConfig', 'defaultMessage': 'Save configuration'},
	saving: {id: 'common.saving', 'defaultMessage': 'Saving…'},
	saved: {id: 'flowConfig.saved', 'defaultMessage': 'Saving'},
	fieldRequired: {id: 'validation.fieldRequired', 'defaultMessage': 'This field is required'},
	missingRequiredFieldsTitle: {id: 'validation.missingRequiredFieldsTitle', 'defaultMessage': 'These fields are mandatory and must be filled in:'},
    saveFailed: {id: 'flowConfig.saveFailed', defaultMessage: 'Saving configuration failed: {error}'},
});

export function getFlowTitle(flow) {
    let args = {};
    let selectedChannelKeys = {};
    for (let {node: channel} of flow.channels.edges) {
        selectedChannelKeys[channel.realId] = channel;
    }

    let channelName;

    let selectedChannels = JSON.parse(flow.selectedChannels);
    for (let selected of Object.keys(selectedChannels)) {
        let id = selectedChannels[selected];
        let channel = selectedChannelKeys[id];
        if (channel && channel.name) {
            channelName = channel.name;
        }
        if (channel) {
            args[selected] = channel.channelDef ? channel.channelDef.name : selected;
        }
    }

    let flowTitle = flow.flowDef ? variableResolver(flow.flowDef.title || flow.flowDef.name || '', args) : '<?>';

    let hasName = false;
    if (flow.name) {
        hasName = true;
        flowTitle += " - " + flow.name;
    }
    if (!hasName && channelName) {
        flowTitle += " - " + channelName;
        hasName = true;
    }

    return flowTitle;
}

interface FlowConfigProps {
    createCallback?: (...args: unknown[]) => unknown;
    createStep?: boolean;
    intl: IntlShape;
    relay: object;
    user: User;
    wrapper?: boolean;
}

class FlowConfig extends React.Component<FlowConfigProps> {

    static propTypes = {
		createCallback: PropTypes.func,
		createStep: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
		wrapper: PropTypes.bool
    };

	static defaultProps = {
		createStep: false,
		wrapper: false
	};

    typeName = 'flows';

    static contextTypes = {
        router: PropTypes.object
    };

    loadOptions() {
        let {flow} = this.props.user.organisation;
        let {options} = flow;

        /* we receive options as JSON string */
        let originalOptions = { ...JSON.parse(options) };

        options = {};
        if (originalOptions.stepConfig) {
            Object.keys(originalOptions.stepConfig).map((key) => {
                let value = originalOptions.stepConfig[key];
                Object.keys(value).map((optionKey) => {
                    let optionValue = value[optionKey];
                    options[key + "_" + optionKey] = optionValue;
                });
            });
        }
    }


    constructor(props) {
        super(props);

        let flowDef = this.props.user.organisation.flow.flowDef;
        let {flowChannelDefs} = flowDef;

        let {flow} = this.props.user.organisation;
        let {options} = flow;

        /* we receive options as JSON string */
        let originalOptions = { ...JSON.parse(options) };
        
        // Parse URL parameters
        const urlParams = getQueryParams(window.location.search || '');
        const shouldCloseWindow = urlParams.closeWindow === 'true';
        
        this.state = {
            loaded: false,
            missingRequiredFieldKeys: [],
            shouldCloseWindow: shouldCloseWindow,
        };

        this.missingRequiredAlertRef = null;

        this.metadata = this.collectMetaData(flowDef, flowChannelDefs.edges.map(({node}) => node));

        options = {};
        if (originalOptions.stepConfig) {
            Object.keys(originalOptions.stepConfig).map((key) => {
                let value = originalOptions.stepConfig[key];
                Object.keys(value).map((optionKey) => {
                    let optionValue = value[optionKey];
                    options[key + "_" + optionKey] = optionValue;
                });
            });
        }

        if (this.metadata) {
            let metaDataHelper: MetaDataHelper = this.metadata;
            let fields = metaDataHelper.fields();
            Object.keys(fields).map(fieldKey => {
                if (options[fieldKey] === undefined) {
                    options[fieldKey] = fields[fieldKey].value;
                }
            });
        }
        this.originalOptions = options;
    }

    componentDidMount() {
        return this.props.relay.forceFetch({}, (state) => {
            if (state.done || state.error) {
                this.loadOptions();
                this.setState({loaded: true});
            }
        });
    }


    _recursiveFormPrepare(flow, configOptions, list, configId) {
		const isDeveloper = BrowserPermission.isDeveloper();
		const isPartner2 = BrowserPermission.isPartner2();
		const isPartner1 = BrowserPermission.isPartner1();

        let optionsToSort = Object.keys(configOptions).sort((a, b) => {
            let aConfigOption = configOptions[a] || {};
            let bConfigOption = configOptions[b] || {};

            return (aConfigOption.order || 0) - (bConfigOption.order || 0);
        });

        for (let key of optionsToSort) {
            let configOption = configOptions[key];
            if (configOption) {
                let isOk = true;

                if (configOption.flowEditableOnly === true) {
                    isOk = false;
                }

                if (!isDeveloper && configOption.accessType === ACCESS_TYPE_DEVELOPER) {
                    isOk = false;
                }
                if (!isPartner1 && configOption.accessType === ACCESS_TYPE_PARTNER1) {
                    isOk = false;
                }
                if (!isPartner2 && configOption.accessType === ACCESS_TYPE_PARTNER2) {
                    isOk = false;
                }

                if (!isDeveloper && configOption.developersOnly) {
                    isOk = false;
                }
                if (!isPartner1 && configOption.partner1Only) {
                    isOk = false;
                }
                if (!isPartner2 && configOption.partner2Only) {
                    isOk = false;
                }

                if (isOk) {

                    let handleJavaScript = (script, values, isBoolean) => {
                        return (data, columnPrefixId) => {
                            try {

                                // eslint-disable-next-line no-unused-vars
                                function getValue(field) { // this function can be used in 'eval'
                                    if ((configId + '_' + field) in data) {
                                        return data[configId + '_' + field];
                                    } else if (columnPrefixId && (columnPrefixId + "." + field) in data) {
                                        return data[columnPrefixId + "." + field];
                                    } else if (field in data) {
                                        return data[field];
                                    } else {
                                        let immutableData = Immutable.Map(data);
                                        let path = (columnPrefixId + "." + field).split(".");
                                        if (immutableData.hasIn(path)) {
                                            return immutableData.getIn(path);
                                        }
                                        //fallback to flow options
                                        if (flow && flow.options) {
                                            try {
                                                let globalOptions = JSON.parse(flow.options);
                                                if (globalOptions && globalOptions[field]) {
                                                    return globalOptions[field];
                                                }
                                            } catch (e) {
                                            }
                                        }
                                    }                               
                                    return undefined;
                                }
                                
                                let getOptionValue = getValue; // this function can be used in 'eval'

                                // eslint-disable-next-line no-unused-vars
                                function setTitle(title) {
                                    if (title) {
                                        if (typeof title === 'string') {
                                            configOption.name = title;
                                        } else {
                                            configOption.name = getLocalizedText(title, getLocale());
                                        }
                                    }
                                }

                                // eslint-disable-next-line no-unused-vars
                                function require(scriptDefKey) { // this function can be used in 'eval'
                                    if (!flow || !flow.flowDef || !flow.flowDef.frontendScripts || !scriptDefKey) {
                                        throw new Error("Missing scripts");
                                    }
                                    let frontendScripts = JSON.parse(flow.flowDef.frontendScripts);

                                    if (!frontendScripts[scriptDefKey]) {
                                        throw new Error("Missing script " + scriptDefKey);
                                    }

                                    let exports = {};

                                    // eslint-disable-next-line no-eval
                                    eval(frontendScripts[scriptDefKey]);  // nosemgrep
                                    return exports;
                                }

                                // eslint-disable-next-line no-unused-vars
                                function hasChannelDef(channelDefId, alias: string, noExtended: boolean) { // this function can be used in 'eval'
                                    let selectedChannels = JSON.parse(flow.selectedChannels);
                                    for (let channel of flow.channels.edges) {
                                        if (channel.node.channelDef && (
                                            channel.node.channelDef.realId === channelDefId ||
                                            channel.node.channelDef.type === channelDefId ||
                                            (!noExtended && channel.node.channelDef.extendedFrom && (
                                                channel.node.channelDef.extendedFrom.realId === channelDefId ||
                                                channel.node.channelDef.extendedFrom.type === channelDefId
                                            ))
                                            )) {
                                                if (!alias || selectedChannels[alias] === channel.node.realId) {
                                                    return true;
                                                }
                                        }
                                    }

                                    return false;
                                }

                                let output = null;
                                // eslint-disable-next-line no-unused-vars
                                let json = values; // accessible in eval

                                const staticPrefix = "output = (function userScript () { ";
                                const staticSuffix = "\nreturn output; })();";

                                // eslint-disable-next-line no-eval
                                let result = eval(staticPrefix + script + staticSuffix); // we need this :-( it is invoked in browser // nosemgrep

                                if (result === undefined && output !== null) {
                                    result = output;
                                }

                                if (isBoolean) {
                                    return result ? true : false;
                                } else {
                                    return result;
                                }
                            } catch (e) {
                                console.error("Error in handleJavaScript", script, e);
                                throw e;
                            }
                        };
                    };

                    if (configOption.enumValues) {
                        if (configOption['filterValuesJS']) {
                            configOption['values'] = handleJavaScript(configOption['filterValuesJS'], configOption.enumValues);
                        } else {
                            configOption['values'] = configOption.enumValues;
                        }
                    }
                    list[configId + '_' + key] = configOption;

                    if (configOption['regexp']) {
                        list[configId + '_' + key]['validations'] = {
                            matchRegexp: configOption['regexp']
                        };
                    }
                    if (configOption['channel_id']) {
                        list[configId + '_' + key]['channel'] = flow.channels.edges.map((a) => a.node).find((a) => a.realId === configOption['channel_id']);
                    }
                    if (configOption['channel2_id']) {
                        list[configId + '_' + key]['channel2'] = flow.channels.edges.map((a) => a.node).find((a) => a.realId === configOption['channel2_id']);
                    }

                    if (configOption['prefix']) {
                        list[configId + '_' + key]['addonBefore'] = configOption['prefix'];
                    }
                    if (configOption['suffix']) {
                        list[configId + '_' + key]['addonAfter'] = configOption['suffix'];
                    }
                    list[configId + '_' + key]['required'] = configOption['required'] ? true : false;

                    if (configOption['longDescription']) {
                        list[configId + '_' + key]['longDescription'] = configOption['longDescription'];
                    }

                    let description = "";

                    if (configOption['description']) {
                        description += configOption['description'];
                    }

                    if (configOption['descriptionHtml']) {
                        description += configOption['descriptionHtml'];
                    }

                    if (configOption['examples']) {
                        description += " " + this.props.intl.formatMessage(messages.example) + " " + configOption['examples'];
                    }

                    if (configOption['type'] === 'text' || configOption['type'] === 'boolean') {
                        list[configId + '_' + key]['description'] = description;
                    } else {
                        list[configId + '_' + key]['descriptionHtml'] = description;
                    }

                    if (configOption['subForm']) {
                        let subForm = configOption['subForm'];

                        let columns = {};
                        this._recursiveFormPrepare(flow, subForm.columns, columns, configId + "_" + key + "[]");

                        subForm.columns = columns;
                        list[configId + '_' + key]['subForm'] = subForm;
                    }

                    if (configOption['visibilityJS']) {
                        list[configId + '_' + key]['visibility'] = handleJavaScript(configOption['visibilityJS'], null, true);
                    }
                }
            }
        }

        return list;
    }

    collectMetaData(flowDef, flowChannelDefs) {

        let flow = this.props.user.organisation.flow;

        let configOptions = flow.configOptions;
        if (configOptions) {
            configOptions = JSON.parse(configOptions);
        }

        let list = {};

        for (let stepOptions of Object.values(configOptions)) {
            if (!stepOptions) {
                return;
            }

            for (let options of stepOptions) {

                if (options && options.configOptions) {
                    let configId = options.flowStepConfigDef_id ? options.flowStepConfigDef_id : FLOW_OPTION_DEF_OPTIONS_KEY;
                    // Hide duplicates only within the same section (configId), allow same keys in other sections
                    if (!this._shownKeysAcrossSections) {
                        this._shownKeysAcrossSections = {};
                    }
                    if (!this._shownKeysAcrossSections[configId]) {
                        this._shownKeysAcrossSections[configId] = {};
                    }
                    let filteredConfigOptions = {};
                    Object.keys(options.configOptions).forEach((k) => {
                        if (!this._shownKeysAcrossSections[configId][k]) {
                            this._shownKeysAcrossSections[configId][k] = true;
                            filteredConfigOptions[k] = options.configOptions[k];
                        }
                    });
                    if (Object.keys(filteredConfigOptions).length > 0) {
                        this._recursiveFormPrepare(flow, filteredConfigOptions, list, configId);
                    }
                }
            }
        }

        return declareEditEntity({
            entity: "options",
            graphQL: "Options",
            name: this.props.intl.formatMessage(messages.options),
            fields: (types) => {
                return list;
            }
        });
    }

	// eslint-disable-next-line max-params
    submit = (data) => {
        return new Promise((resolve, reject) => {
            // reset list of missing required fields before validation
            this.setState({missingRequiredFieldKeys: []});
            /* we have to find which options are authentication and which not */
            let {flow} = this.props.user.organisation;

            // Validate required fields before sending to backend
            const fieldErrors = {};
            if (this.metadata && this.metadata._metadata && this.metadata._metadata.fields) {
                Object.keys(this.metadata._metadata.fields).forEach(fieldKey => {
                    const field = this.metadata._metadata.fields[fieldKey];
                    if (field.required) {
                        // Check if field is visible
                        let isVisible = true;
                        if (field.visibility && typeof field.visibility === 'function') {
                            try {
                                isVisible = field.visibility(data);
                            } catch (e) {
                                // If visibility function fails, assume visible
                                isVisible = true;
                            }
                        }

                        if (isVisible) {
                            // Check if field is empty - for dropdowns, 0 and false are valid values.
                            // Localized empty defaults are objects like {cs: '', en: ''}; treat those as empty too.
                            const currentValue = data[fieldKey];
                            if (!hasRequiredValue(currentValue)) {
                                fieldErrors[fieldKey] = this.props.intl.formatMessage(messages.fieldRequired);
                            }
                        }
                    }
                });
            }

            // If there are validation errors, show them and don't submit
            if (Object.keys(fieldErrors).length > 0) {
                if (this.editorRef && this.editorRef.form) {
                    this.editorRef.form.setInputValidationErrors(fieldErrors);
                }
                // store missing field keys for render list
                this.setState({missingRequiredFieldKeys: Object.keys(fieldErrors)});
                reject(new Error('Validation failed'));
                return;
            }

            let newOptions = JSON.parse(flow.options);
            if (!newOptions) {
                newOptions = {};
            }

            //Fers said: "Save it to options.step[step.id][opt]"
            if (!newOptions.stepConfig) {
                newOptions.stepConfig = {};
            }

            for (let key of Object.keys(data)) {
                let val = data[key] !== undefined ? data[key] : null;

                data[key] = val;
                let splittedKey = key.split('_');
                if (!newOptions.stepConfig[splittedKey[0]]) {
                    newOptions.stepConfig[splittedKey[0]] = {};
                }
                newOptions.stepConfig[splittedKey[0]][splittedKey[1]] = val;
            }

            let mutationArgs = {
                flow_id: this.props.user.organisation.flow.realId,
                organisation_id: this.props.user.organisation.realId,
                options: JSON.stringify(newOptions),
            };

			let onSuccess = (result) => {
				// Unpause flow after successful configuration - Step 3 (only for flows from scenarios)
				if (this.props.user.scenario) {
					let {flow} = this.props.user.organisation;
					
					this.props.relay.commitUpdate(
						new PlayPauseFlowMutation({
							flow_id: flow['realId'],
							organisation_id: this.props.user.organisation['realId'],
							pause: false // unpause flow
						}), {
							onSuccess: () => {
								// Now handle createCallback if it exists
								if (this.props.createCallback) {
									this.props.createCallback(result);
									return;
								}
								
								resolve();
							},
							onFailure: (transaction) => {
								// If unpause fails, still continue but log error
								console.error('Failed to unpause flow after configuration:', transaction);
								
								// Still handle createCallback if it exists
								if (this.props.createCallback) {
									this.props.createCallback(result);
									return;
								}
								
								resolve();
							}
						}
					);
				} else {
					// For direct flow configuration (not from scenario), just handle createCallback or resolve
					if (this.props.createCallback) {
						this.props.createCallback(result);
						return;
					}
					
					resolve();
				}
			};

			let onFailure = (transaction) => {
				// Simple error handling - show default error
				mutationError(transaction);
				try {
					const errObj = (transaction && transaction.getError && transaction.getError()) || null;
					const msg = (errObj && errObj.message)
						|| (transaction && transaction.source && transaction.source.errors && transaction.source.errors[0] && transaction.source.errors[0].message)
						|| 'Unknown error';
					const {formatMessage} = this.props.intl;
					displayError(formatMessage(messages.saveFailed, {error: msg}));
				} catch (e) {
					// ignore
				}
				reject(transaction);
			};

            try {
                if (this.props.relay) {
                    this.props.relay.commitUpdate(
                        new ConfigFlowMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
                    );
                }
            } catch (error) {
                displayError(error).catch((e) => {
                /* ignore error */
                });

                reject(error);
            }
        }).then(() => {
            console.error("Flow configuration saved successfully");
            // Check if we should close the window instead of navigating
            if (this.state.shouldCloseWindow) {
                window.close();
                return;
            }
            
            let {flow} = this.props.user.organisation;

            let path = urlMapping.getUrl(types['flows'], "view", flow);
            this.context.router.push(path);
        });
    };

    render() {
        if (!this.state.loaded) {
            return renderLoadingPanel();
        }

        let {flow} = this.props.user.organisation;

        let options = this.originalOptions;
		let metadata = this.metadata;

		if (this.props.createStep) {
			Object.keys(metadata._metadata.fields).forEach(fieldKey => {
				if (true === metadata._metadata.fields[fieldKey].skipOnCreate) {
					delete metadata._metadata.fields[fieldKey];
				}
			});
		}

        let flowTitle = getFlowTitle(flow);

		let content = (<div>
			<p><FormattedMessage defaultMessage="Configure how {flowName} is working."
								id="flowConfig.description1"
								values={{
									flowName: flowTitle,
									productName: config.PRODUCT_NAME
								}}
			/></p>
			<EditorWithSubmit
				ref={(ref) => { this.editorRef = ref; }}
				buttonTitle={this.props.intl.formatMessage(messages.save, {'entity': this.metadata.pluralName()})}
				cancelable
				data={options}
				metadata={metadata}
				cancel={() => {
					// Check if we should close the window instead of navigating
					if (this.state.shouldCloseWindow) {
						window.close();
						return;
					}

					this.context.router.push(urlMapping.getUrl(types['flows'], "view", flow));
				}}
				submit={this.submit}
				urlMapping={urlMapping}
			>
				{this.state.missingRequiredFieldKeys && this.state.missingRequiredFieldKeys.length > 0 ? (
					<div className="alert alert-danger" ref={(r) => { this.missingRequiredAlertRef = r; }} style={{marginBottom: '1em'}}>
						<strong><FormattedMessage {...messages.missingRequiredFieldsTitle} /></strong>
						<ul>
							{this.state.missingRequiredFieldKeys.map((k) => {
								let label = (this.metadata && this.metadata._metadata && this.metadata._metadata.fields && this.metadata._metadata.fields[k] && this.metadata._metadata.fields[k].name) ? this.metadata._metadata.fields[k].name : k;
								return (<li key={k}>{label}</li>);
							})}
						</ul>
					</div>
				) : null}
			</EditorWithSubmit>
		</div>);

		if (this.props.wrapper) {
			return content;
		}

        return (
            <AppPanel breadcrumbParams={[
                {type: types['flows'], data: flow},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                {ScenarioApply.getRawQueryParams().style === 'flexibee' && (
                    <div className="flexibeeHeader">
                        <img className="flexibeeHeaderAbra" src="/cdn/logos/logo-abra-flexi.svg" alt="ABRA Flexi logo"  />
                        <span className="flexibeeHeaderPlus">+</span>
                        <img className="flexibeeHeaderDativery" src="/cdn/dativery.svg" alt="Dativery logo" />
                    </div>
                )}


				<h2>{flowTitle}</h2>

				{content}
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(FlowConfig), (props) => {
    return props.user.organisation && props.user.organisation.flow;
}), {
    initialVariables: {
        organisationId: '',
        flowId: '',
        scenarioId: '',
        scenarioSelected: false,
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')}
                },
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                    channels(first: 200) {
                        edges {
                            node {
                                id,
                                realId,
                                name,
                                channelDef_id,
                                channelDef {
                                    id,
                                    realId,
                                    name,
                                    icon
                                }
                            }
                        }
                    },
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    flow(id: $flowId) {
                        id,
                        realId,
                        name,
                        organisation_id,
                        activated,
						selectedChannels,
						channels(first: 100) {
							edges {
								node {
									id,
									realId,
									name,
									organisation_id,
									channelDef_id,
									channelDef {
										id,
										realId,
										name,
                                        icon,
                                        type,
										state,
                                        extendedFrom {
                                            id,
                                            realId,
                                            type
                                        }
									}
								}
							}
						},
                        flowDef {
                            id,
                            realId,
							name,
							title,
                            type,
                            frontendScripts,
                            flowChannelDefs(first:100) {
                                edges {
                                    node {
                                        id,
                                        name,
                                        channelDef {
                                            id,
                                            realId,
                                            type,
                                            name,
                                            extendedFrom {
                                                id,
                                                realId,
                                                type
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        options,
                        configOptions,
                        selectedChannels,
                        enabled
                    }
                },
            }
        `,
    },
});
